import { render } from "./_CatalogueFilter.vue?vue&type=template&id=27243bcd"
import script from "./_CatalogueFilter.vue?vue&type=script&lang=js"
export * from "./_CatalogueFilter.vue?vue&type=script&lang=js"

import "./_CatalogueFilter.vue?vue&type=style&index=0&id=27243bcd&lang=css"

import exportComponent from "/home/runner/work/musora-web-platform/musora-web-platform/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__